import { ReactNode } from 'react'

type WizardGuideProps = {
  title: string
  children: ReactNode
}

export function WizardGuide({ title, children }: WizardGuideProps) {
  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{title}</h2>
      <div className="flex flex-col gap-3 text-sm text-muted-foreground">{children}</div>
    </div>
  )
}

type GuideTermProps = {
  term: string
  children: ReactNode
}

export function GuideTerm({ term, children }: GuideTermProps) {
  return (
    <p className="text-sm text-muted-foreground">
      <strong className="font-medium text-foreground">{term}</strong>{' '}
      {children}
    </p>
  )
}
